module.exports = __webpack_public_path__ + "img/operation_drag.03bc34ca.svg";